import type { ReactNode } from 'react';
import { Alert } from '..';
import { QR_CODE_READER_ERROR } from '../../config/consts';

export interface ScanAlertMessages {
  permissionDenied: ReactNode;
  invalidCode: ReactNode;
  timeout: ReactNode;
  allowCamera: ReactNode;
}

interface ScanAlertsProps {
  error: string;
  messages: ScanAlertMessages;
}

export function ScanAlerts({ error, messages }: ScanAlertsProps) {
  if (error === QR_CODE_READER_ERROR.PERMISSION_DENIED) {
    return (
      <Alert severity="warning" variant="filled">
        {messages.permissionDenied}
      </Alert>
    );
  }
  if (error === QR_CODE_READER_ERROR.INVALID_QR_CODE) {
    return <Alert severity="warning">{messages.invalidCode}</Alert>;
  }
  if (error === QR_CODE_READER_ERROR.TIMEOUT) {
    return <Alert severity="info">{messages.timeout}</Alert>;
  }
  if (error === QR_CODE_READER_ERROR.ALLOW_CAMERA) {
    return <Alert severity="info">{messages.allowCamera}</Alert>;
  }

  return null;
}
